import { Inject, Injectable, PLATFORM_ID, APP_ID, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Router,  ActivatedRoute } from '@angular/router';

import { Request, Response } from 'express';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';

// import { API_URL, TRANSLATE_PATH_URL } from '../../config.json';
import { environment } from 'src/environment';

import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { SettingsContainer } from '../types/settings';
import { ApiResponse } from '../types/apiResponse';

import * as Cookies from 'js-cookie';
import { User } from '../types/user';
import { Config, Locales, Region, Settings } from '../types/settings';
import { UTM } from '../types/utm';
import { userInfo } from 'os';
import { env } from 'process';


@Injectable({ providedIn: 'root' })
export class SettingsService {
  private settingsUrl = `${environment.API_URL}/v3/auth/platform_settings?d_type=web&logged_in=0&locale=`; // URL to web api
  public loaderSource = new BehaviorSubject(true);

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  public static userInfo: User;
  public static configInfo: Config;
  public static settingsInfo: Settings;
  public static utm: UTM;
  langKeys;
  localesdata;
  planInfo;
  trialDate;
  public static selectedLocale: string;
  locale;
  isMobile;
  isTablet;
  isDesktopDevice;
  webpFlag;
  browserRegion;
  regionTv;
  s3_epg_path = "";
  display_epg_time_format:12;
  imagePath;
  epg_series_placeholder;
  epg_video_placeholder;
  userSettingsData;
  platformSettings: ApiResponse<SettingsContainer>;
  freeTrialDays;
  imageClassMobile = {
    card: { "default": "sm", "400": "sm", "768": "md" },
    banner: { "default": "sm", "400": "sm", "768": "md" },
    background: { "default": "sm", "400": "sm", "768": "md" },
    logo: { "default": "sm", "400": "sm", "768": "md" },
    icon: { "default": "sm", "400": "sm", "768": "md" }
  };

  imageClassDesktop = {
    card: { "default": "sm", "1080": "md", "1440": "md", "2160": "md" },
    banner: { "default": "md", "1080": "lg", "1440": "lg", "2160": "xl" },
    background: { "default": "md", "1080": "lg", "1440": "lg", "2160": "xl" },
    logo: { "default": "md", "1080": "md", "1440": "lg", "2160": "lg" },
    icon: { "default": "sm", "1080": "sm", "1440": "md", "2160": "md" }
  };

  innerWidth;
  finalObject = {
    card:'',
    banner:'',
    background:'',
    icon:'',
    logo:''
  }

  public prefix_slug_movies: string;
  public prefix_slug_series: string;
  public prefix_slug_artical: string;
  public prefix_slug_article_series: string;
  public prefix_slug_livechannel: string;

  constructor(private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: object,
    public route: ActivatedRoute,
    public router: Router,
    public location: Location,
    @Inject(APP_ID) private appId: string, private injector: Injector) {
      if (isPlatformServer(this.platformId)) {
      const request = this.injector.get(REQUEST);
      this.browserRegion = request.path.split("/")[1];
      //request.route
      this.locale = request.query.locale;
      //this.locale = 'en-US';
    } else if (isPlatformBrowser(this.platformId)) {
      this.locale = localStorage.getItem('locale');
      router.events.subscribe((val) => {
        if(location.path() != ''){
          const request = location.path();
          this.browserRegion = request.split("/")[1];
        } 
      });
    }
    if (isPlatformBrowser(this.platformId)) {
      this.checkWebP(support => {
        if(support) {
            this.webpFlag = 1;
        }else{
            this.webpFlag = 2;
        }
      })
      this.getImageResolution();
    }
  }

  /** GET settings from the server */
  async getSettings(): Promise<SettingsContainer> {
    try {
      if(!this.locale) {
        this.locale = 'en-US';
      }
      this.platformSettings = await this.http
        .get<ApiResponse<SettingsContainer>>(this.settingsUrl+this.locale)
        .toPromise();
      if (this.platformSettings.data) {
        //this.loaderSource.next(false);
        const userSettingsApiRes = await this.getUserSettings();
        SettingsService.userInfo = userSettingsApiRes.user;
        SettingsService.configInfo = userSettingsApiRes.configuration;
        this.planInfo = this.platformSettings?.data?.plan[userSettingsApiRes?.configuration?.region?.region_code]?.amount;
        this.freeTrialDays = this.platformSettings?.data?.plan[userSettingsApiRes?.configuration?.region?.region_code]?.free_trial_days;
        if ( this.platformSettings?.data?.plan[userSettingsApiRes?.configuration?.region?.region_code]?.free_trial_days > 0) this.trialDate = this.platformSettings?.data?.plan[userSettingsApiRes?.configuration?.region?.region_code]?.free_trial_text;
        SettingsService.settingsInfo = this.platformSettings.data.settings;
        this.imagePath = SettingsService.settingsInfo.image_base_path;
        environment.IMAGE_PATH_URL = this.platformSettings.data.settings.image_base_path;

        this.s3_epg_path  = SettingsService.settingsInfo['s3_epg_path'];
        this.epg_series_placeholder = SettingsService.settingsInfo['epg_series_placeholder'];
        this.epg_video_placeholder = SettingsService.settingsInfo['epg_video_placeholder'];
        //if(SettingsService.selectedLocale) {
        if (userSettingsApiRes) SettingsService.selectedLocale = userSettingsApiRes?.configuration?.region['locale'];

        this.prefix_slug_movies = (SettingsService.settingsInfo.paywall_movies_details_page_sitemap_url) ? SettingsService.settingsInfo.paywall_movies_details_page_sitemap_url : 'v';
        this.prefix_slug_series = (SettingsService.settingsInfo.paywall_series_details_page_sitemap_url) ? SettingsService.settingsInfo.paywall_series_details_page_sitemap_url : 'vs';
        this.prefix_slug_artical = (SettingsService.settingsInfo.paywall_article_details_page_sitemap_url) ? SettingsService.settingsInfo.paywall_article_details_page_sitemap_url : 'ar';
        this.prefix_slug_article_series = (SettingsService.settingsInfo.paywall_article_series_details_page_sitemap_url) ? SettingsService.settingsInfo.paywall_article_series_details_page_sitemap_url : 'ars';
        this.prefix_slug_livechannel = (SettingsService.settingsInfo.paywall_channel_details_page_sitemap_url) ? SettingsService.settingsInfo.paywall_channel_details_page_sitemap_url : 's';

      }

      //}

      return this.platformSettings.data;
    } catch (err) {
      this.loaderSource.next(false);
      console.error(err);
      return null;
    }
  }


  getUserSettings:any = async() => {
    try {
      if(!this.locale) {
        this.locale = 'en-US';
      }
      let userSettingsUrl = environment.API_URL + '/' + environment.v3_version + `auth/user_settings?d_type=web&logged_in=0&locale=${this.locale}`;
      const reqObj = {
        d_type: 'web',
        logged_in: 0,
        locale: this.locale
      }
      const apiResponse: any = await this.http
      .post<ApiResponse<SettingsContainer>>(userSettingsUrl, reqObj)
      .toPromise();
      this.userSettingsData = apiResponse?.data;
      return apiResponse?.data;
    } catch (err) {
      this.loaderSource.next(false);
      console.error(err);
      return null;
    }
  }

  /** Get Locale and Region Data */
  public getRegion(): Array<Region> {
    let region = SettingsService.configInfo.region;
    if (region) {
      return region;
    }
    return null;
  }

  public getCountryCode(): any {
    let country_code = SettingsService.configInfo.country_code;
    if (country_code) {
      return country_code;
    }
    return '';
  }

  public getBrowserRegion(): any {
    let region = SettingsService.configInfo.region;
    if(this.browserRegion == 'tv-guide') this.browserRegion = this.regionTv;
    if (region) {
      if (this.browserRegion) {
        if (this.browserRegion != region['region_code']) {
            let browser = [];
            browser["region_code"] = this.browserRegion;
            return browser;
        }
      }
      return region;
    }
    return null;
  }

  public getLocale(): Array<Locales> {
    let locales = this.platformSettings?.data?.configuration?.locales;
    if (locales) {
      this.localesdata = locales;
      return locales;
    }
    return null;
  }

  public async getLocaleData(locale) {
    let locales = this.platformSettings?.data?.configuration?.locales;
    let json_path_obj = locales.find(loc => {
      return loc.lang_code === locale;
    });
    this.langKeys = await this.http.get(json_path_obj.path).toPromise()
  }

  public getSelectedLocale() {
    return SettingsService.selectedLocale;
  }

  public async getLocaleStaticData(locale) {
    try{
      let locales = this.platformSettings?.data?.configuration?.locales;
      let json_path_obj = locales.find(loc => {
        return loc.lang_code === locale;
      });
      //this.langKeys = await this.http.get(environment.TRANSLATE_PATH_URL + locale + '.json').toPromise()
      this.langKeys = await this.http.get(json_path_obj.path).toPromise(); 
    }catch(error){
      console.error(error);
    }
  }

  // post api call for checking email from getstarted widget
  async checkEmailAvailable(email){
    try{
      let reg = this.route.snapshot.firstChild.url[0].path;
      let countryCode = SettingsService.configInfo.country_code;
      let local;
      this.route.queryParams.subscribe(params => {
        local = params['locale'];
      });
      const requestBody = {
        d_type:'web',
        country_code:countryCode,
        locale:local,
        region:reg,
        email: email,
      };
      const collectionUrl = `${environment.API_URL}/v2/auth/check/user`;
      const apiResponse = await this.http.post<ApiResponse<any>>(collectionUrl , requestBody ).toPromise();
      return apiResponse.data;
    }catch(err){
      console.error(err);
      return null;
    }
  }

  getImageResolution() {
    this.innerWidth = window.innerWidth;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(window.navigator.userAgent);
    const imageClass = isMobile ? this.imageClassMobile : this.imageClassDesktop;
    let breakpoint = 'default';

    if (isMobile) {
      if (this.innerWidth >= 768) {
        breakpoint = '768';
      } else if (this.innerWidth >= 400) {
        breakpoint = '400';
      }
    } else {
      if (this.innerWidth >= 2160) {
        breakpoint = '2160';
      } else if (this.innerWidth >= 1440) {
        breakpoint = '1440';
      } else if (this.innerWidth >= 1080) {
        breakpoint = '1080';
      }
    }
    
    this.finalObject = {
      card: imageClass.card[breakpoint],
      banner: imageClass.banner[breakpoint],
      background: imageClass.background[breakpoint],
      icon: imageClass.icon[breakpoint],
      logo: imageClass.logo[breakpoint]
    };
  }

  // getImage(image_name, carousel_type_mobile, carousel_type_web) {
  //   //const fileExt = image_name.split('.').pop();
  //   if (isPlatformBrowser(this.platformId)) {
  //     const filename = image_name.split('.').slice(0, -1).join('.');
  //     let fileExt;
  //     if(this.webpFlag == 1){
  //       fileExt = "webp";
  //     } else {
  //       fileExt = image_name.split('.').pop();
  //     }
  //     var newFilename = filename+'_'+carousel_type_web+'.'+fileExt;
  //     if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  //       newFilename = filename+'_'+carousel_type_mobile+'.'+fileExt;
  //     }
  //     return environment.IMAGE_PATH_URL_CONVERTED+newFilename;
  //   }
  // }

  getImage(image, type = null) {
    if(image.includes('https' || 'http')){
     return image;
    }else{
      if (type) {
        let resolution = this.finalObject[type];
        const filename = image.split('.').slice(0, -1).join('.');
        return environment.IMAGE_PATH_URL + filename + "_" + resolution +".webp";
      } else {
        const filename = image.split('.').slice(0, -1).join('.');
        return environment.IMAGE_PATH_URL + filename + ".webp";
      }
    }
  }

  getSrcSet(image_name, carousel_type_mobile, carousel_type_web, type) {
    const filename = image_name.split('.').slice(0, -1).join('.');
    let fileExt;
    if(type == 'original'){
       fileExt = image_name.split('.').pop();
    } else {
       fileExt = "webp";
    }
    var mobilename = environment.IMAGE_PATH_URL_CONVERTED + filename + '_' + carousel_type_mobile + '.' + fileExt;
    var webname = environment.IMAGE_PATH_URL_CONVERTED + filename + '_' + carousel_type_web + '.' + fileExt;
    return mobilename + " " + carousel_type_mobile + "w," + webname + " " + carousel_type_web + "w";
  }

  navigateTo(url: string): void {
    const locale = localStorage.getItem('locale');
    if (locale) {
      url = url.includes('?') ? `${url}&locale=${locale}` : `${url}?locale=${locale}`;
    }
    window.location.href = url;
  }

  getSetUTMValues(url){
    this.route.queryParams.subscribe(params => {
      const searchParams = new URLSearchParams();
      const utm_keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid']
      for (const key of utm_keys) {
        if (params.hasOwnProperty(key)) {
          searchParams.append(key, params[key]);
        }
      }
      const queryString = searchParams.toString();
      if(queryString.length != 0) url = url.includes('?') ? `${url}&${queryString}` : `${url}?${queryString}`;
    });
    return url;
  }

  checkWebP(callback) {
    if (isPlatformBrowser(this.platformId)) {
      var webP = new Image();
      webP.onload = webP.onerror = function () {
          callback(webP.height == 2);
      };
      webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    }
  }

  getPaywallUrl(video: any, region: any): string {
    if (!video || !region) return '';
    let url = environment.BASE_URL + '/' + region['region_code'];
    let prefix;
    let content_slug;
    if(video.value.content_type == 'video') {
      prefix = this.prefix_slug_movies;
      if (video.value.is_series == '1') prefix = this.prefix_slug_series;
    } else if ( video.value.content_type == 'article') {
      prefix = this.prefix_slug_artical;
      if (video.value.is_series == '1') prefix = this.prefix_slug_article_series;
    } else if(video.value.is_livechannel == '1') {
      prefix = this.prefix_slug_livechannel;
      content_slug = video.value.slug;
    }
    if (video.value.is_series == '1')
      content_slug = video.value.has_season ? video.value.seasons_slug : video.value.series_slug;
    else content_slug = video.value?.content_slug;

    return url + '/' + prefix + '/' + content_slug;
  }

  getHeaderText(translationKeyValue) {
    let headerText;
    const freeTrialDays = this.freeTrialDays;
    if (freeTrialDays > 0 ) {
      headerText = this.generateHeaderText(translationKeyValue, [[ '{{trial_days}}',  freeTrialDays]]) || `Create an account now, watch ${freeTrialDays} days for free, cancel within ${freeTrialDays} days and no fees will be charged`;
    } else {
      headerText = this.langKeys['plans.start_subscription.btn'] ||  'Start Subscription';
    }
    return headerText;
  }

  generateHeaderText(translationText, replacements) {
    if (replacements.length === 0) {
      return translationText;
    }

    const [textToReplace, replacementText] = replacements[0];

    const newText = translationText.replaceAll(textToReplace, replacementText);
    return this.generateHeaderText(newText, replacements.slice(1));
  }

}
